import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = ['filterable', 'input', 'noResults']

  static values = {
    visibleFilterableItems: {
      default: true,
      type: Boolean,
    },
  }

  connect() {
    this.disabled = false
    this.element.addEventListener('on-page-filter:disable', this.#disable.bind(this))
    this.element.addEventListener('on-page-filter:enable', this.#enable.bind(this))

    if (this.inputTargets.some((input) => input.value)) {
      this.filter()
    }
  }

  clear(event) {
    if (this.disabled) return

    if (event) event.preventDefault()
    this.inputTargets.forEach((input) => { input.value = '' })
    this.filter()
  }

  filter(event) {
    if (this.disabled) return

    if (event) event.preventDefault()

    const filterables = this.filterableTargets
    const inputs = this.inputTargets
    let visibleFilterableItems = false

    filterables.forEach((filterable) => {
      const isMatch = inputs.every((input) => {
        const query = input.value.toLowerCase()

        if (query === '') return true

        const { onPageFilterSearchContext } = input.dataset
        let filterableContent

        if (onPageFilterSearchContext) {
          const searchContextElement =
            filterable.querySelector(`[data-on-page-filter-search-context='${onPageFilterSearchContext}']`)
          filterableContent = searchContextElement.textContent.toLowerCase()
        } else {
          filterableContent = filterable.textContent.toLowerCase()
        }

        const { onPageFilterOperator } = input.dataset

        switch (onPageFilterOperator) {
          case 'contains':
            return filterableContent.includes(query)
          case 'eq':
            return filterableContent === query
          case 'gt':
            return filterableContent > query
          case 'lt':
            return filterableContent < query
          default:
            return filterableContent.includes(query)
        }
      })

      if (isMatch) {
        filterable.classList.remove('hidden')
        filterable.removeAttribute('hidden')
        visibleFilterableItems = true
      } else {
        filterable.classList.add('hidden')
        filterable.setAttribute('hidden', '')
      }
    })

    this.visibleFilterableItemsValue = visibleFilterableItems

    this.element.dispatchEvent(
      new CustomEvent('on-page-filter:complete', { bubbles: true }),
    )
  }

  visibleFilterableItemsValueChanged() {
    if (this.disabled) return

    if (this.hasNoResultsTarget) {
      if (this.visibleFilterableItemsValue) {
        leave(this.noResultsTarget)
      } else {
        enter(this.noResultsTarget)
      }
    }
  }

  #disable() {
    this.clear()
    this.disabled = true
    this.inputTargets.forEach((input) => input.disabled = true)
  }

  #enable() {
    this.disabled = false
    this.inputTargets.forEach((input) => input.disabled = false)
    this.filter()
  }
}
